import { modals } from '@mantine/modals';
import { IconMailExclamation } from '@tabler/icons-react';
import { useInvoiceSelection } from 'app/Private/Clients/Detail/UnhandledInvoicesTab/use-invoice-selection';
import { UnrecoverableReasonForm } from 'app/Private/Reasons/UnrecoverableReasonForm/UnrecoverableReasonForm';
import { iconProps } from 'components/icon-props';
import { tKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import type { InvoiceAction, UnhandledInvoice } from 'modules/AtRisk/api/use-load-unhandled-client';
import type { ActionButtonDefinition } from '../use-build-action-buttons';
import { computeCommonProps, useBatchAction } from './common';
import { openUnhandledInvoiceSelectionModal } from './open-unhandled-invoice-selection-modal';

export function useMarkAsUnrecoverable(): (
  action: InvoiceAction,
  invoices: Array<UnhandledInvoice>,
) => ActionButtonDefinition {
  const { t } = useTranslation();
  const batchAction = useBatchAction();
  const { selectedInvoiceIds } = useInvoiceSelection();

  return (action, invoices) => {
    // First let the user confirm/refine the invoice selection, then ask for the reason
    const handler = () =>
      openUnhandledInvoiceSelectionModal({
        title: t(tKeys.DEBTOR.REACTION.SELECT_INVOICES),
        selectedInvoiceIds,
        invoices,
        actionType: 'mark_as_unrecoverable',
        onNext: ({ invoiceIds }) => {
          modals.closeAll();
          modals.open({
            size: 'sm',
            title: t(tKeys.MARK_AS_UNRECOVERABLE),
            children: (
              <UnrecoverableReasonForm
                onSubmit={values => batchAction('mark_as_unrecoverable', invoiceIds, values)}
              />
            ),
          });
        },
      });

    return {
      icon: <IconMailExclamation {...iconProps()} />,
      translationKey: tKeys.MARK_AS_UNRECOVERABLE,
      onClick: handler,
      ...computeCommonProps(action, invoices),
    };
  };
}
